module.exports = __webpack_public_path__ + "static/media/skip the line.ba4a7671.svg";